<template>
    <div class="flex w-full justify-center items-center h-screen">
        <div class="container w-[28rem] bg-[#f8f4f3] p-8 rounded-md shadow-md">

            <div class="flex flex-col items-center pb-4 mb-4">
                <img src="/icon-512x512.png" alt="Vue Logo" />
                <span>期限管理システム リミトック</span>
            </div>
            <div class="text-center">
                <p class="text-base font-semibold text-gray-600"><span class="text-red-500">404</span>:ページが見つかりません</p>
                <!-- <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">404</h1> -->
                <div class="mt-10 flex justify-center">
                    <a href="/login" class="w-full">
                        <el-button type="primary" class="w-full">ログイン</el-button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NotFound'
});
</script>

<style scoped>
h1 {
    color: red;
}
</style>